import { get } from '../utils/objectHelpers';

export default class {
    constructor(serviceResp, devFlags, featureFlags) {
        this.modules = get(serviceResp, 'modules', {});
        this.meta = get(serviceResp, 'meta', {});
        this.isSmall = get(serviceResp, 'isSmall', false);
        this.devFlags = {
            isShowDiag: get(devFlags, 'isShowDiag', false),
            isAutomation: get(devFlags, 'isAutomation', false)
        };
        this.featureFlags = featureFlags || {};
    }
}
